import httpClient from '@emmacare/common/api/httpClient'

import { PATIENT_LIST } from 'src/constants'

export default {
  getPatientList() {
    return httpClient.get({
      pathname: PATIENT_LIST
    })
  }
}
